<div ng-controller="registersController as regCtrl" class="registers-admin-list">
    <div class="list-filter list-filter-tools" ng-show="regCtrl.showFilter">
        <div centuri-list-filter class="list-filter-elements" config="regCtrl.filterConfig" callback="regCtrl.filterCallback"></div>
    </div>
    <div id="managed-component"></div>
</div>